import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import TabbedPane from '../../components/plain/TabbedPane';

import TabBrNames from './components/TabBrNames';
import TabBrAuthors from './components/TabBrAuthors';
import TabBrContent from './components/TabBrContent';
import TabBrDerivatives from './components/TabBrDerivatives';
import TabBrHonors from './components/TabBrHonors';
import TabBrDocLinks from './components/TabBrDocLinks';
import TabBrTopicLinks from './components/TabBrTopicLinks';
import TabBrFiles from './components/TabBrFiles';

import {getLanguage} from '../../util/localStorage';
import {getDefinedValue} from '../../util/tools';
import {FORM_WORK_PLAIN} from '../../util/consts/forms';

class WorkPlainPage extends PlainPage {

	constructor(props) {
		super(props);
		this.formPath = FORM_WORK_PLAIN;
		this.formTitle = 'Твір';
		this.buildInstanceCard = this.buildCard;
	}
	async completeInit() {
		return true;
	}
	componentDidMount = async () => {
		this.init('Work')
		document.title = 'BOM. ' + this.formTitle;
	}

	buildCard = (workInstance) => {
		let currentLanguage = getLanguage();
		let card = '';
		
		let titleArea = '';
		let titleAreaCt = ''
		for(let ttl of workInstance.rootField.value.record.value.title.value) {
			if(ttl.value.titleType.value == 'Modern') {
				if( ttl.value.language.value == currentLanguage ) {
					titleArea = ttl.value.mainName.value; 
					if( ttl.value.subName.value ) 
						titleArea += ": " + ttl.value.subName.value;
					break;
				} else {
					titleAreaCt = getDefinedValue(ttl.value.mainName.value, '');
				}
			}
		}
		if( titleArea == '' )
			titleArea = titleAreaCt;

		let author = '', compiler = '', editor = '', translator = '', illustrator = '';
		for(let con of workInstance.rootField.value.record.value.contributor.value) {
			let contriburorType = con.value.role.value;
			let contriburorName = this.realm.getEnumerationItemText( this.enumContributorType, contriburorType);
			if( contriburorType == 'A01' ) { // AUTHOR
				author = this.addContributorName(author, con, '');
			} else if( contriburorType == 'C01' ) { // COMPILER
				compiler = this.addContributorName(compiler, con, contriburorName);
			} else if( contriburorType == 'B01' ) { // EDITOR
				editor = this.addContributorName(editor, con, contriburorName);
			} else if( contriburorType == 'B06' ) { // TRANSLATOR
				translator = this.addContributorName(translator, con, contriburorName);
			} else if( contriburorType == 'A12' ) { // ILLUSTRATOR
				illustrator = this.addContributorName(illustrator, con, contriburorName);
			}
		}
		let respArea = author
		if( compiler )
			respArea += (respArea) ? " ; " + compiler : compiler;
		if( editor )
			respArea += (respArea)? " ; " + editor : editor;
		if( translator )
			respArea += (respArea)? " ; " + translator : translator;
		if( illustrator )
			respArea += (respArea)? " ; " + illustrator : illustrator;
		
		card += titleArea;
		if( respArea )
			card += " / " + respArea;
		return card;
	}
	addContributorName(currentName, contributor, prefix) {
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of contributor.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.shortName.value ) {
				name = n;
				break;
			}
		}
		if( name == null && contributor.value.names.value.length > 0)
			name = contributor.value.names.value[0];
		if( name != null  && name.value.shortName.value ) {
			let pref = getDefinedValue(prefix, '');
			if( currentName )
				currentName += ', ' + name.value.shortName.value;
			else
				currentName = pref + ' ' + name.value.shortName.value;
		} 
		return currentName;
	}

	createTab = (tabId) => {
		let instance = this.state.instance;
		let fieldRecord = instance.rootField.value.record;
		let fieldLink = fieldRecord.value.link;
		if( tabId == 'names' )
			return <TabBrNames plain={this} instance={instance} parentField={fieldRecord} readOnly={this.instanceReadOnly} />;
		if( tabId == 'authors' )
			return <TabBrAuthors plain={this} instance={instance} parentField={fieldRecord} readOnly={this.instanceReadOnly} />;
		if( tabId == 'content' )
			return <TabBrContent plain={this} instance={instance} parentField={fieldRecord} readOnly={this.instanceReadOnly} />;
		if( tabId == 'docLinks' )
			return <TabBrDocLinks plain={this} instance={instance} parentField={fieldLink} readOnly={this.instanceReadOnly} />;
		if( tabId == 'topicLinks' )
			return <TabBrTopicLinks plain={this} instance={instance} parentField={fieldLink} readOnly={this.instanceReadOnly} />;
		if( tabId == 'files' )
			return <TabBrFiles plain={this} instance={instance} parentField={fieldLink} readOnly={this.instanceReadOnly} />;
		if( tabId == 'derivatives' )
			return <TabBrDerivatives plain={this} instance={instance} parentField={fieldRecord} readOnly={this.instanceReadOnly} />;
		if( tabId == 'honors' )
			return <TabBrHonors plain={this} instance={instance} parentField={fieldRecord} readOnly={this.instanceReadOnly} />;
		return null;
	}

	renderBody() {
		let tabs = [
			{
				rowId: 'tabs',
				tabs: [
					{ tabId: 'names', tabTitle: 'Назви', },
					{ tabId: 'authors', tabTitle: 'Автори', },
					{ tabId: 'content', tabTitle: 'Зміст', },
					{ tabId: 'topicLinks', tabTitle: 'Теми класифікатора', },
					{ tabId: 'docLinks', tabTitle: 'Зв\'язки з документами', },
					{ tabId: 'files', tabTitle: 'Електронні копії', },
					{ tabId: 'derivatives', tabTitle: 'Екранізації', },
					{ tabId: 'honors', tabTitle: 'Відзнаки і нагороди', },
				]
			},
		];
		
		let instance = this.state.instance;
		let fieldRecord = instance.rootField.value.record;

		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}

				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginTop: '10px'} }} 
					/>
				</div>

			</div>
		);
	}
}

export default WorkPlainPage;
